import { render, staticRenderFns } from "./CommentNarrowTable.vue?vue&type=template&id=2a564382&scoped=true&"
import script from "./CommentNarrowTable.vue?vue&type=script&lang=ts&"
export * from "./CommentNarrowTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommentNarrowTable.vue?vue&type=style&index=0&id=2a564382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a564382",
  null
  
)

export default component.exports